import { gql } from './generated/gql';

const CREATE_STATIC_TOKEN_INTEGRATION = gql(/** @complexity 2 */ `
  mutation createStaticTokenIntegration(
    $platform: String!
    $token: String!
    $host: String
    $email: String
  ) {
    createStaticTokenIntegration(
      platform: $platform
      token: $token
      extra: { host: $host, email: $email }
    ) {
      id
      platform
    }
  }
`);

export default CREATE_STATIC_TOKEN_INTEGRATION;
